import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { CustomerLoanType } from '../../../customer.model';
import { LoanStatus, AccountHintData, BaseDialogActionData, ButtonColor, CommonActionKey } from 'common';

@Component({
    selector: 'ifb-customer-loans-assignment-dialog',
    templateUrl: './customer-loans-assignment-dialog.component.html',
    styleUrls: ['./customer-loans-assignment-dialog.component.scss'],
    standalone: false
})
export class CustomerLoansAssignmentDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];

  title: string;
  loans: any[] = [];
  excludedStatus: LoanStatus;

  form: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<CustomerLoansAssignmentDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({ loanNumber: '' });

    switch (data.type) {
      case CustomerLoanType.PendingLoans:
        this.title = 'Assign new pending account';
        this.excludedStatus = LoanStatus.Frozen;
        break;

      default:
        this.title = 'Assign new account';
        this.excludedStatus = LoanStatus.Pending;
        break;
    }
  }

  static show(dialog: MatDialog, customerId: number, type: CustomerLoanType): Observable<any> {
    return dialog.open(CustomerLoansAssignmentDialogComponent, {
      width: '510px',
      data: {
        customerId: customerId,
        type: type
      },
      closeOnNavigation: true
    }).afterClosed();
  }

  selectedLoan(event: AccountHintData): void {
    const existingLoanNumber = this.loans.some(l => l.loanNumber === event.loanNumber);
    if (!existingLoanNumber) {
      this.loans.push({ id: event.id, loanNumber: event.loanNumber, description: `${event.loanNumber} - ${event.businessName}` });
    }
    this.form.controls.loanNumber.setValue('');
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      return this.dialogRef.close(this.loans.length ? _.map(this.loans, 'id') : null);
    }

    this.dialogRef.close(false);
  }
}
